<template>
  <div class="news">
    <top-nav></top-nav>
    <banner  :bgImage="bgImage"></banner>
    <div class="news-box">
      <ul class="news-tab-title">
        <li class="title-item" :class="{current:tab==1}" @click="toTab(1)">睿哲新闻</li>
        <li class="title-item" :class="{current:tab==2}" @click="toTab(2)">行业新闻</li>
      </ul>

      <div class="news-tab-content clearfix">
        <div class="content-item" v-for="(news,index) in tabContent" :key="'news'+index" @click="toDetail(news.id)">
          <div class="content-img" :style="`background-image:url(${news.summaryImg})`"></div>
          <div class="content-title">
            {{news.title}}
          </div>
          <div class="time">{{news.createTime}}</div>
          <div class="more">read more>></div>
        </div>
      </div>
    </div>
    <div class="page">
      <Page :total="total" :page-size="pageSize" :current="current" @on-change="pageChange" size="small" show-elevator show-total />

    </div>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "news",
  data() {
    return {
      bgImage:'../../../static/images/newsBanner.jpg?011801',
      showMask: false,
      tab: 1,
      tabContent: '',
      total: 0,
      pageSize: 6,
      current: 1
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {
    this.getTabContent()
  },

  methods: {
    toDetail(id){
      this.$router.push({path:'/newsDetail',query:{id:id}})
    },
    toTab(num){
      this.tab = num;
      this.getTabContent()
    },
    pageChange(current) {
      this.current = current;
      this.getTabContent();
    },
    getTabContent(){
      let url = '/api/gw/findAllRzNews'
      if(this.tab==1){
         url = '/api/gw/findAllRzNews'
      }else{
        url = '/api/gw/findAllHyNews'
      }
      let params = {
        page: this.current,
        pageSize: this.pageSize
      }
      this.$axios.get(url,{params}).then((data)=>{
        this.tabContent = data.data.data.list;
        this.total = data.data.data.total
      }).catch((err)=>{
        console.log(err);
      })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
.news {
  .news-box{
    width: 1200px;
    margin: 95px auto;
    position: relative;
    .news-tab-title{
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%,0);
      -ms-transform: translate(-50%,0);
      -moz-transform: translate(-50%,0);
      -webkit-transform: translate(-50%,0);
      li{
        width: 106px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #e4e4e4;
        float: left;
        color: #818181;
        font-size: 16px;
        cursor: pointer;
        &:nth-of-type(1) {
          border-right: 0;
          border-radius: 3px 0 0 3px;
        }
        &:nth-of-type(2) {
          border-left: 0;
          border-radius: 0 3px 3px 0;
        }
        &.current {
          background-color: #73a9f1;
          color: #fff;
          border: 0;
        }
      }
    }
    .news-tab-content{
      width: 100%;
      height: auto;
      padding-top: 100px;
      .content-item{
        width: 400px;
        height: 316px;
        float: left;
        margin-bottom: 60px;
        cursor: pointer;
        .content-img{
          width: 400px;
          height: 230px;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
        }
        .content-title{
          width: 100%;
          height: 61px;
          font-size: 16px;
          color: #777;
          text-align: left;
          line-height: 22px;
          padding: 15px;
          margin-bottom: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .time{
          height: 14px;
          line-height: 14px;
          font-size: 14px;
          color: #818181;
          margin-left: 20px;
          float: left;
        }
        .more{
          color: #313131;
          text-transform: uppercase;
          margin-right: 20px;
          float: right;
          cursor: pointer;
        }
        &:hover .content-title,.more,.time{
          color: #73a9f1;
        }
      }
    }
  }
  .page{
    margin: 30px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/news.vue